module.exports = __webpack_public_path__ + "img/partner34.cd84e188.png";